"use client";

import "./blog-bundles";

/**
 * Renders nothing — it exists so the blog routes' client chunk retains the
 * import above, which is what registers the namespace in the browser for the
 * blog components that are client components.
 */
export default function BlogI18n() {
  return null;
}
